<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 flex justify-between mb-6">
      <span class="text-[#2d82b5] font-semibold">
        ACT for {{ info.fullName }}
      </span>
      <span class="text-sm">
        {{ $t("common.student_id") }}:
        <span class="font-semibold">{{ info.studentCode }}</span>
        <span class="ml-4">
          {{ $t("common.grade") }}:
          <span class="font-semibold">{{ info.grade }}</span>
        </span>
      </span>
    </div>

    <div class="md-layout-item md-size-100">
      <p class="font-medium mb-3">
        {{ $t("smi_sri.detail_about_tests") }}
      </p>

      <md-table class="table-pdf-assessment">
        <md-table-row class="text-center">
          <md-table-cell>{{ $t("smi_sri.test_date") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.act_composite_score") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.act_math_score") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.act_science_score") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.act_english_score") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.act_reading_score") }}</md-table-cell>
        </md-table-row>

        <md-table-row
          class="text-center"
          v-for="(row, index) in dataTable"
          :key="'ACT' + index"
        >
          <md-table-cell>{{
            convertDateFromServer(row.testDate, "date")
          }}</md-table-cell>
          <md-table-cell>{{ row.actCompositeScore }}</md-table-cell>
          <md-table-cell>{{ row.actMathScore }}</md-table-cell>
          <md-table-cell>{{ row.actScienceScore }}</md-table-cell>
          <md-table-cell>{{ row.actEnglishScore }}</md-table-cell>
          <md-table-cell>{{ row.actReadingScore }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  name: "export-pdf-act",
  props: ["info", "dataTable"],
  data() {
    return {
      convertDateFromServer
    };
  }
};
</script>
